import React from 'react';
import { fetchOrGetFromCache } from 'acscp/store/imageCache';
import log from 'loglevel';

export type CachedImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

interface CachedImageState {
    cachedSrc?: string;
}

export class CachedImage extends React.Component<CachedImageProps, CachedImageState> {
    constructor(props: CachedImageProps) {
        super(props);
        this.state = {};
    }

    componentDidMount(): void {
        this.updateImageCache();
    }

    componentDidUpdate(prevProps: Readonly<CachedImageProps>): void {
        if (this.props.src !== prevProps.src) {
            this.updateImageCache();
        }
    }

    private updateImageCache(): void {
        this.setState({ cachedSrc: undefined });

        if (!!this.props.src) {
            fetchOrGetFromCache(this.props.src)
                .then(cachedUrl => {
                    this.setState({ cachedSrc: cachedUrl });
                })
                .catch(err => log.error);
        }
    }

    render(): JSX.Element | null {
        const { src, alt, ...rest } = this.props;
        const { cachedSrc } = this.state;

        if (!cachedSrc) {
            return null;
        }

        return (<img src={cachedSrc} alt={alt} {...rest} />);
    }
}
